export const yMap = () => {
    ymaps.ready(init);
    function init() {
        // Создание карты.
        var myMap = new ymaps.Map("map-one", {
            // Координаты центра карты.
            // Порядок по умолчанию: «широта, долгота».
            // Чтобы не определять координаты центра карты вручную,
            // воспользуйтесь инструментом Определение координат.
            center: [55.016889, 73.43528],
            // Уровень масштабирования. Допустимые значения:
            // от 0 (весь мир) до 19.
            zoom: 13
        });
        myMap.geoObjects
            .add(new ymaps.Placemark([55.016889, 73.43528]))





        var myMapTwo = new ymaps.Map("map-two", {
            // Координаты центра карты.
            // Порядок по умолчанию: «широта, долгота».
            // Чтобы не определять координаты центра карты вручную,
            // воспользуйтесь инструментом Определение координат.
            center: [55.016889, 73.43528],
            // Уровень масштабирования. Допустимые значения:
            // от 0 (весь мир) до 19.
            zoom: 16,
        })
        myMapTwo.options.set('autoFitToViewport', 'always');
        console.log(myMapTwo.options)
        myMapTwo.geoObjects
            .add(new ymaps.Placemark([55.016889, 73.43528]))
    }

}
